// extracted by mini-css-extract-plugin
export default {"table":"EquipmentsFamilies_table__q-lAM","search":"EquipmentsFamilies_search__BHH2q"};